// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_container__-h4N5{
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    padding-top: 30px;
}
.Login_banner__ZGNkM{
    height: calc(100vh - 154px);
    width: 40%;
    padding-bottom: 50px;
}
@media(max-width: 1080px){
    .Login_container__-h4N5{
        display: block;
        height: auto;
    }
    .Login_banner__ZGNkM{
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        margin-top: -25px;
    }
}
@media(max-width: 600px){
    .Login_container__-h4N5{
        padding-top: 0;
    }
}
.Login_bottomBar__1U\\+aq{
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 20px 25px 20px 30px;
    background-color: #40798C;
    border-radius: 0 0 30px 30px;
}
@media(max-width: 1080px){
    .Login_bottomBar__1U\\+aq{
        margin-top: -5px;
        padding-bottom: 50px;
        border-radius: 30px 30px 0 0;
    }
}
@media(max-width: 450px){
    .Login_bottomBar__1U\\+aq{
        flex-direction: column;
        padding: 25px 25px 60px 25px;
    }
}
.Login_bottomBarText__aG6sr{
    margin-right: 25px;
    font-size: 31px;
    color: #FFFFFF;
    line-height: 31px;
}
.Login_image__StAXm{
    height: calc(100% - 88px);
    width: 100%;
    border-radius: 30px 30px 0 0;
    object-fit: cover;
}
@media(max-width: 1080px){
    .Login_image__StAXm{
        margin-top: -30px;
        object-position: top;
    }
}
.Login_signupButton__s4Xe1{
    min-width: 62px;
    margin-left: auto;
}
@media(max-width: 450px){
    .Login_signupButton__s4Xe1{
        width: calc(100% - 90px);
        margin-top: 20px;
    }
}
.Login_formContainer__eWHMJ{
    display: flex;
    justify-content: center;
    height: calc(100vh - 174px);
    width: 60%;
    padding-top: 40px;
    overflow-y: auto;
    overflow-x: hidden;
}
@media(max-width: 1080px){
    .Login_formContainer__eWHMJ{
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        height: 700px;
        width: 500px;
        padding-top: 0;
    }
}
@media(max-width: 600px){
    .Login_formContainer__eWHMJ{
        height: auto;
        width: calc(100% - 30px);
        margin: 30px 15px 90px 15px;
    }
}
.Login_form__5n2LA{
    width: 500px;
}
.Login_formNamesRow__WB03x{
    display: flex;
}
.Login_heart__ot1Wq{
    height: 47px;
    width: 56px;
}
.Login_header__\\+cFFh{
    text-align: left !important;
    word-break: normal;
}
.Login_name__CVPm8 input{
    width: 190px;
}
.Login_singleLineInput__I3YJU{
    display: block !important;
    margin-top: 15px;
}
.Login_singleLineInput__I3YJU input{
    width: calc(100% - 40px);
}
@media(max-width: 600px){
    .Login_form__5n2LA{
        width: 100%;
    }
    .Login_formNamesRow__WB03x{
        display: block;
    }
    .Login_name__CVPm8{
        display: block !important;
        margin-top: 15px;
    }
    .Login_name__CVPm8 input{
        width: calc(100% - 45px);
    }
    .Login_singleLineInput__I3YJU input{
        width: calc(100% - 45px);
    }
}
.Login_formBottom__NKDfp{
    display: flex;
    align-items: center;
    margin-top: 50px;
}
.Login_forgotPasswordLink__9dOfu{
    margin-left: 8px;
    margin-right: auto;
}
.Login_button__bPXVQ{
    margin-left: auto;
}
.Login_divider__jyH9L{
    margin-top: 35px;
    margin-bottom: 40px;
    border-top: 1px solid #1F363D1A;
}
.Login_receiptsLink__UnsmK{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    padding: 0 45px;
    color: #40798C;
    background-color: #FFFFFF;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    text-decoration: none;
    border-radius: 500px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;AACxB;AACA;IACI;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI;QACI,gBAAgB;QAChB,oBAAoB;QACpB,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI;QACI,OAAO;QACP,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;QACZ,wBAAwB;QACxB,2BAA2B;IAC/B;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,cAAc;IAClB;IACA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":[".container{\n    display: flex;\n    flex-direction: row-reverse;\n    height: 100%;\n    padding-top: 30px;\n}\n.banner{\n    height: calc(100vh - 154px);\n    width: 40%;\n    padding-bottom: 50px;\n}\n@media(max-width: 1080px){\n    .container{\n        display: block;\n        height: auto;\n    }\n    .banner{\n        display: flex;\n        flex-direction: column-reverse;\n        width: 100%;\n        margin-top: -25px;\n    }\n}\n@media(max-width: 600px){\n    .container{\n        padding-top: 0;\n    }\n}\n.bottomBar{\n    display: flex;\n    align-items: center;\n    margin-top: -5px;\n    padding: 20px 25px 20px 30px;\n    background-color: #40798C;\n    border-radius: 0 0 30px 30px;\n}\n@media(max-width: 1080px){\n    .bottomBar{\n        margin-top: -5px;\n        padding-bottom: 50px;\n        border-radius: 30px 30px 0 0;\n    }\n}\n@media(max-width: 450px){\n    .bottomBar{\n        flex-direction: column;\n        padding: 25px 25px 60px 25px;\n    }\n}\n.bottomBarText{\n    margin-right: 25px;\n    font-size: 31px;\n    color: #FFFFFF;\n    line-height: 31px;\n}\n.image{\n    height: calc(100% - 88px);\n    width: 100%;\n    border-radius: 30px 30px 0 0;\n    object-fit: cover;\n}\n@media(max-width: 1080px){\n    .image{\n        margin-top: -30px;\n        object-position: top;\n    }\n}\n.signupButton{\n    min-width: 62px;\n    margin-left: auto;\n}\n@media(max-width: 450px){\n    .signupButton{\n        width: calc(100% - 90px);\n        margin-top: 20px;\n    }\n}\n.formContainer{\n    display: flex;\n    justify-content: center;\n    height: calc(100vh - 174px);\n    width: 60%;\n    padding-top: 40px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n@media(max-width: 1080px){\n    .formContainer{\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        height: 700px;\n        width: 500px;\n        padding-top: 0;\n    }\n}\n@media(max-width: 600px){\n    .formContainer{\n        height: auto;\n        width: calc(100% - 30px);\n        margin: 30px 15px 90px 15px;\n    }\n}\n.form{\n    width: 500px;\n}\n.formNamesRow{\n    display: flex;\n}\n.heart{\n    height: 47px;\n    width: 56px;\n}\n.header{\n    text-align: left !important;\n    word-break: normal;\n}\n.name input{\n    width: 190px;\n}\n.singleLineInput{\n    display: block !important;\n    margin-top: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 40px);\n}\n@media(max-width: 600px){\n    .form{\n        width: 100%;\n    }\n    .formNamesRow{\n        display: block;\n    }\n    .name{\n        display: block !important;\n        margin-top: 15px;\n    }\n    .name input{\n        width: calc(100% - 45px);\n    }\n    .singleLineInput input{\n        width: calc(100% - 45px);\n    }\n}\n.formBottom{\n    display: flex;\n    align-items: center;\n    margin-top: 50px;\n}\n.forgotPasswordLink{\n    margin-left: 8px;\n    margin-right: auto;\n}\n.button{\n    margin-left: auto;\n}\n.divider{\n    margin-top: 35px;\n    margin-bottom: 40px;\n    border-top: 1px solid #1F363D1A;\n}\n.receiptsLink{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 48px;\n    padding: 0 45px;\n    color: #40798C;\n    background-color: #FFFFFF;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    text-decoration: none;\n    border-radius: 500px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__-h4N5`,
	"banner": `Login_banner__ZGNkM`,
	"bottomBar": `Login_bottomBar__1U+aq`,
	"bottomBarText": `Login_bottomBarText__aG6sr`,
	"image": `Login_image__StAXm`,
	"signupButton": `Login_signupButton__s4Xe1`,
	"formContainer": `Login_formContainer__eWHMJ`,
	"form": `Login_form__5n2LA`,
	"formNamesRow": `Login_formNamesRow__WB03x`,
	"heart": `Login_heart__ot1Wq`,
	"header": `Login_header__+cFFh`,
	"name": `Login_name__CVPm8`,
	"singleLineInput": `Login_singleLineInput__I3YJU`,
	"formBottom": `Login_formBottom__NKDfp`,
	"forgotPasswordLink": `Login_forgotPasswordLink__9dOfu`,
	"button": `Login_button__bPXVQ`,
	"divider": `Login_divider__jyH9L`,
	"receiptsLink": `Login_receiptsLink__UnsmK`
};
export default ___CSS_LOADER_EXPORT___;
